// extracted by extract-css-chunks-webpack-plugin
module.exports = {"play-button":"T9Tym","video-wrapper":"tvrNs"};